module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.mission.startTime)))]), _vm._v(" "), _c('td', {
    class: {
      'text-primary': _vm.isMissionEditor
    }
  }, [(_vm.isMissionEditor) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.isMissionEditor'),
      "triggers": ['hover']
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.mission.title) + "\n        "), _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2)]) : _c('span', [_vm._v(_vm._s(_vm.mission.title) + " "), _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.mission.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.mission.creator)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.counts.popover', _vm.mission.slotCounts),
      "triggers": ['hover']
    }
  }, [_vm._v("\n      " + _vm._s(_vm.mission.slotCounts.assigned + _vm.mission.slotCounts.external + _vm.mission.slotCounts.unassigned) + "/" + _vm._s(_vm.mission.slotCounts.total) + "\n    ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.mission.isAssignedToAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.status.assigned'),
      "triggers": ['hover']
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mission.isAssignedToAnySlot && _vm.mission.isRegisteredForAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.status.registered'),
      "triggers": ['hover']
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-lg text-muted",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mission.isAssignedToAnySlot && !_vm.mission.isRegisteredForAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.isUserInCommunity ? _vm.$t('mission.list.slot.counts.available.popover.community', {
        open: _vm.mission.slotCounts.open
      }) : _vm.$t('mission.list.slot.counts.available.popover', {
        open: _vm.mission.slotCounts.open
      }),
      "triggers": ['hover']
    }
  }, [_vm._v("\n      " + _vm._s(_vm.mission.slotCounts.open) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.mission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec63d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionListRow.vue
// module id = 472
// module chunks = 0